<h3 class="titulo">ECG por Terceiros</h3>
<bn-loading-overlay></bn-loading-overlay>
<div class="container">
  <form [formGroup]="pesquisaForm" class="mt-3 mx-auto" (keyup.enter)="focusableSubmit.click()">
    <div class="row">
      <div class="col">
        <h3>Pesquisa</h3>
      </div>
      <div class="col-auto">
        <button
          type="button"
          class="btn btn-primary no-margin"
          [routerLink]="['/ecg-por-terceiros/cadastro']">
          <i class="fa fa-file-signature"></i>
          Cadastrar Terceiro
        </button>
      </div>
      <div class="col-auto">
        <button type="button" class="btn btn-light" (click)="limpar()">Limpar</button>
      </div>
      <div class="col-auto">
        <button #focusableSubmit type="button" class="btn btn-success no-margin" (keydown.enter)="buscar()"
                (click)="buscar()">Pesquisar
        </button>
      </div>
    </div>
    <div class="bn-form-row mt-6">
      <div class="bn-form-group col-md-6">
        <label class="form-label" for="ecgTerceiros"><b>ECG pago por: </b></label>
        <ng-select
          [items]="listarTodosEcgPorTerceiros"
          bindLabel="nomeTipoPagamentoEcgTerceiro"
          bindValue="ide"
          placeholder="Todos"
          formControlName="ideEcgTerceiro"
          ngDefaultControl
        >
        </ng-select>
      </div>
    </div>
  </form>
</div>

<app-ecg-por-terceiros-listagem
  *ngIf="pesquisado"
  [ecgTerceirosPesquisado]="ecgTerceirosPesquisado"
  [filtroBusca]="obterFiltrosBusca()"
>
</app-ecg-por-terceiros-listagem>
